// Modules
import React, { useState } from 'react';
import i18n from 'i18n-react';
import { connect } from 'react-redux';

// Components
import Button from '../button/ButtonView';
import InputField from '../inputfield/InputFieldView';
import SearchResults from './SearchResults';

// Styling
import './actionMenu.scss';
import './header.scss';
import './searchField.scss';
import withRouter from '../../../hoc/withRouter';
import { createSearchParams } from 'react-router-dom';
// eslint-disable-next-line import/no-unresolved
import AppConfig from 'appconfig';
import useOutsideClick from '../../../hooks/useOutsideClick';

const Header = (props) => {
    const {
        navigate,
        searchParam,
        logOut,
        loadSearchResults,
        resetSearchResults,
        isLoadingSearchResults,
        searchResults,
    } = props;
    const [search, setSearch] = useState(searchParam);
    const [showSearchResults, setShowSearchResults] = useState(false);
    const [showActionMenu, setShowActionMenu] = useState(false);

    const handleSearchFieldChange = (e) => {
        setSearch(e.target.value);
        if (e.target.value.length >= 3) {
            onSearch(e.target.value);
            setShowSearchResults(true);
        } else {
            setShowSearchResults(false);
        }
    };

    const onSearch = (searchParam) => {
        const data = {
            allowCached: false,
            keyword: searchParam,
            meta: {
                resultsPerPage: 20,
                page: 1,
            },
        };
        loadSearchResults({ data });
    };

    const toggleActionMenu = () => {
        setShowActionMenu(!showActionMenu);
    };

    const handleClickOutsideSearch = () => {
        setShowSearchResults(false);
    };

    const handleClickOutsideActionMenu = () => {
        setShowActionMenu(false);
    };

    const searchRef = useOutsideClick(handleClickOutsideSearch);
    const menuRef = useOutsideClick(handleClickOutsideActionMenu);

    return (
        <div className="header">
            <div className="pull-left">
                <div className="hostfield">{AppConfig.activeEnvironment.hubEnvironment} | {AppConfig.activeEnvironment.hubUrl}</div>
            </div>
            <div className="pull-right">
                <div className="searchfield" ref={searchRef}>
                    <div className="input-group">
                        <InputField
                            type="search"
                            inputGroupAlreadyExist={true}
                            name="search"
                            defaultValue={search}
                            placeholder={
                                i18n.translate('searchResult.searchFrom', { minAmountOfCharacters: '3' }) + '...'
                            }
                            noDefaultFormatting={true}
                            autocomplete="off"
                            onChange={handleSearchFieldChange}
                            onFocus={handleSearchFieldChange}
                        />
                        <div className="input-group-btn">
                            <Button
                                className="btn-zoeken"
                                onClick={() => {
                                    resetSearchResults();
                                    navigate({ pathname: '/search_results', query: { search } });
                                }}
                            />
                        </div>
                        <SearchResults
                            searchResults={searchResults}
                            showSearchResults={showSearchResults}
                            isLoading={isLoadingSearchResults}
                            onSelectCompany={(item) => {
                                resetSearchResults();
                                navigate('/companies/' + item.id);
                            }}
                            onSelectAdministration={(item) => {
                                resetSearchResults();
                                navigate(
                                    '/companies/' +
                                        item.companyId +
                                        '/licenses/' +
                                        item.licenseId +
                                        '/administrations/' +
                                        item.id,
                                );
                            }}
                            onClickAmountOfResults={() => {
                                resetSearchResults();
                                navigate({
                                    pathname: '/search_results',
                                    search: createSearchParams({
                                        search,
                                    }).toString(),
                                });
                            }}
                        />
                    </div>
                </div>
                <div className="action-menu" onClick={toggleActionMenu} ref={menuRef}>
                    <span className="header-btn toggle-action-menu" />
                    {showActionMenu && (
                        <div className="menu">
                            <div className="item" onClick={() => logOut()}>
                                {i18n.translate('account.logout')}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    searchQuery: state.router.location.search,
    searchResults: state.appData.searchResults,
    isLoadingSearchResults: state.uiState.componentState.searchResults.loading,
});

const mapDispatchToProps = {
    logOut: () => ({ type: 'LOGOUT' }),
    resetSearchResults: () => ({ type: 'RESET_SEARCH_RESULTS' }),
    loadSearchResults: ({ data }) => ({ type: 'LOAD_SEARCH_RESULTS', data }),
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
